import { render, staticRenderFns } from "./my_template.vue?vue&type=template&id=a0ad770a&scoped=true&"
import script from "./my_template.vue?vue&type=script&lang=js&"
export * from "./my_template.vue?vue&type=script&lang=js&"
import style0 from "./my_template.vue?vue&type=style&index=0&id=a0ad770a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ad770a",
  null
  
)

export default component.exports